import { render, staticRenderFns } from "./token-expired.vue?vue&type=template&id=45ddac64&"
import script from "./token-expired.vue?vue&type=script&lang=js&"
export * from "./token-expired.vue?vue&type=script&lang=js&"
import style0 from "./token-expired.vue?vue&type=style&index=0&id=45ddac64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports